document.addEventListener("DOMContentLoaded", () => {
    handleLoadingAnimation();  // 竭� 繝ｭ繝ｼ繝�ぅ繝ｳ繧ｰ蜃ｦ逅�ｒ蜈医↓螳溯｡�
});

// 逕ｻ髱｢縺ｮ鬮倥＆繧剃ｿｮ豁｣縺吶ｋ髢｢謨ｰ
function setVh() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
}

// 蛻晏屓螳溯｡�
setVh();

// 逕ｻ髱｢繝ｪ繧ｵ繧､繧ｺ譎ゅ↓繧る←逕ｨ�医い繝峨Ξ繧ｹ繝舌�縺ｮ螟牙虚縺ｫ蟇ｾ蠢懶ｼ�
window.addEventListener("resize", setVh);

// 繝ｭ繝ｼ繝�ぅ繝ｳ繧ｰ蜃ｦ逅�
function handleLoadingAnimation() {
    const images = document.querySelectorAll(".loadingImage");
    const progressBar = document.querySelector(".progressBar__inner");
    const logo = document.querySelector(".loadingLogo");
    const loadingScreen = document.querySelector(".loading");

    const totalImages = images.length;
    let loadedCount = 0;

    images.forEach((img, index) => {
        setTimeout(() => {
            img.style.opacity = "1";
            loadedCount++;

            // 繝ｭ繝ｼ繝�ぅ繝ｳ繧ｰ繝舌�譖ｴ譁ｰ
            const progress = (loadedCount / totalImages) * 100;
            progressBar.style.width = `${progress}%`;

            // 繝ｭ繧ｴ繧偵ヵ繧ｧ繝ｼ繝峨い繧ｦ繝�
            if (progress > 50) {
                logo.style.opacity = "0";
                logo.style.transition = "opacity 1s ease-in-out";
            }

            // 縺吶∋縺ｦ縺ｮ逕ｻ蜒上′繝ｭ繝ｼ繝峨＆繧後◆繧� `.loading` 繧帝撼陦ｨ遉ｺ縺ｫ縺吶ｋ
            if (loadedCount === totalImages) {
                setTimeout(() => {
                    loadingScreen.style.opacity = "0";
                    loadingScreen.style.transition = "opacity 1s ease-in-out";

                    setTimeout(() => {
                        loadingScreen.style.display = "none";

                        // 繝ｭ繝ｼ繝�ぅ繝ｳ繧ｰ螳御ｺ�ｾ後↓莉悶�蜃ｦ逅�ｒ螳溯｡�
                        initPageFunctions();
                    }, 1000);
                }, 500);
            }
        }, index * 100);
    });
}


function initFadeSlider() {
    let items = document.querySelectorAll(".loopImage__item");
    let currentIndex = 0;
    let total = items.length;

    if (total < 2) return; // 繧ｹ繝ｩ繧､繝峨′1譫壹＠縺九↑縺��ｴ蜷医�蜃ｦ逅�ｒ繧ｹ繧ｭ繝��

    function switchImage() {
        items.forEach((item, index) => {
            item.style.opacity = index === currentIndex ? "1" : "0";
        });

        currentIndex = (currentIndex + 1) % total;
    }

    // 4遘偵＃縺ｨ縺ｫ蛻�ｊ譖ｿ縺�
    setInterval(switchImage, 4000);
}

// 逕ｻ蜒上ぜ繝ｼ繝�繧｢繝九Γ繝ｼ繧ｷ繝ｧ繝ｳ繧堤匱轣ｫ
function initZoomAnimation() {
    const img = document.querySelector(".fadeZoomAnime");
    if (img) {
        img.classList.add("active");
    }
}

// #sec01 繧ｺ繝ｼ繝�縺ｨ繧ｹ繧ｯ繝ｭ繝ｼ繝ｫ
function initFadeZoomScroll() {
    const elements = document.querySelectorAll(".fadeZoom");

    if (!('IntersectionObserver' in window)) {
        // 蜿､縺�ヶ繝ｩ繧ｦ繧ｶ蜷代￠繝輔か繝ｼ繝ｫ繝舌ャ繧ｯ
        window.addEventListener("scroll", function checkVisibility() {
            const windowHeight = window.innerHeight;
            elements.forEach(el => {
                const rect = el.getBoundingClientRect();
                if (rect.top < windowHeight - 100) { // 50 竊� 100 縺ｫ隱ｿ謨ｴ�亥ｰ代＠譌ｩ繧√↓逋ｺ轣ｫ��
                    el.classList.add("active");
                }
            });
        });
        return;
    }

    // Intersection Observer API 繧剃ｽｿ逕ｨ
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add("active");
                observer.unobserve(entry.target); // 1蝗樣←逕ｨ縺励◆繧臥屮隕冶ｧ｣髯､
            }
        });
    }, { 
        rootMargin: "-100px 0px", // 逕ｻ髱｢荳九ｈ繧�100px譌ｩ縺冗匱轣ｫ
        threshold: 0 // 0 縺ｧ縲悟ｰ代＠縺ｧ繧りｦ九∴縺溘ｉ逋ｺ轣ｫ縲�
    });

    elements.forEach(el => observer.observe(el));
}

// header縺ｮ繝�く繧ｹ繝亥�繧頑崛縺�
function initSectionTextChange() {
    const sections = document.querySelectorAll("section");
    const titleElement = document.querySelector(".navWrap__title");
    const textElement = document.querySelector(".navWrap__text");
    const fadeLists = document.querySelectorAll(".fadeList"); // 縺吶∋縺ｦ縺ｮ fadeList 繧貞叙蠕�
    let currentSection = null;
    let isFirstLoad = true;

    function updateContent(section) {
        if (currentSection === section) return;
        currentSection = section;

        const newTitle = section.getAttribute("data-title");
        const newText = section.getAttribute("data-text").replace(/\n/g, "<br>");
        const targetId = section.getAttribute("data-target"); // `data-target` 縺ｧ蟇ｾ蠢懊☆繧� fadeList 繧貞叙蠕�

        if (titleElement && newTitle && textElement && newText) {
            if (isFirstLoad) {
                titleElement.textContent = newTitle;
                textElement.innerHTML = newText;
                isFirstLoad = false;
            } else {
                titleElement.style.opacity = 0;
                textElement.style.opacity = 0;

                setTimeout(() => {
                    titleElement.textContent = newTitle;
                    textElement.innerHTML = newText;
                    titleElement.style.opacity = 1;
                    textElement.style.opacity = 1;
                }, 300);
            }
        }

        // `.fadeList` 縺ｮ `active` 繧ｯ繝ｩ繧ｹ繧堤ｮ｡逅�
        fadeLists.forEach((fadeList) => {
            if (fadeList.getAttribute("data-id") === targetId) {
                fadeList.classList.add("active"); // 蟇ｾ蠢懊☆繧� fadeList 縺ｫ `active` 繧定ｿｽ蜉�
            } else {
                fadeList.classList.remove("active"); // 縺昴ｌ莉･螟悶� `active` 繧貞炎髯､
            }
        });
    }

    function handleScroll() {
        let activeSection = null;

        sections.forEach((section) => {
            const rect = section.getBoundingClientRect();
            if (rect.top < window.innerHeight / 2 && rect.bottom > window.innerHeight / 2) {
                activeSection = section;
            }
        });

        if (activeSection) {
            updateContent(activeSection);
        }
    }

    window.addEventListener("scroll", handleScroll);
    handleScroll();
}

// #sec02縺ｮ繧ｯ繝ｪ繝��繧｢繝九Γ
function initClipImageAnimation() {
    const clipImages = document.querySelectorAll(".clipImage");

    if (!('IntersectionObserver' in window)) {
        // 蜿､縺�ヶ繝ｩ繧ｦ繧ｶ蜷代￠繝輔か繝ｼ繝ｫ繝舌ャ繧ｯ�医せ繧ｯ繝ｭ繝ｼ繝ｫ繧､繝吶Φ繝茨ｼ�
        window.addEventListener("scroll", function checkVisibility() {
            const windowHeight = window.innerHeight;
            clipImages.forEach(el => {
                const rect = el.getBoundingClientRect();
                if (rect.top < windowHeight - 100) {
                    el.classList.add("active");
                }
            });
        });
        return;
    }

    // Intersection Observer 繧剃ｽｿ逕ｨ
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add("active");
                observer.unobserve(entry.target); // 荳蠎ｦ逋ｺ轣ｫ縺励◆繧臥屮隕悶ｒ隗｣髯､
            }
        });
    }, {
        rootMargin: "-100px 0px",
        threshold: 0
    });

    clipImages.forEach(el => observer.observe(el));
}

// #sec02縺ｮ閭梧勹繝輔ぉ繝ｼ繝峨い繝九Γ
function initBgImageFadeAnimation() {
    const bgImages = document.querySelectorAll('.bgImage');
    
    function handleScroll() {
        bgImages.forEach(img => {
            const rect = img.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const fadeInStart = windowHeight * 0.5; // 逕ｻ髱｢荳�80%縺九ｉ繝輔ぉ繝ｼ繝峨う繝ｳ髢句ｧ�
            const fadeOutStart = windowHeight * 0.5; // 逕ｻ髱｢荳�40%縺ｧ繝輔ぉ繝ｼ繝峨い繧ｦ繝磯幕蟋�
            
            if (rect.top < fadeInStart && rect.bottom > fadeOutStart) {
                const opacity = Math.min(1, Math.max(0.2, (rect.bottom - fadeOutStart) / (fadeInStart - fadeOutStart)));
                img.style.opacity = opacity;
                img.style.transition = 'opacity 0.6s ease-in-out';
            } else {
                img.style.opacity = 0;
            }
        });
    }
    
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // 蛻晏屓螳溯｡�
}

// #sec03縺ｮ縺ｼ縺九＠繧｢繝九Γ
function initBlurImageAnimation() {
    const blurImages = document.querySelectorAll(".blurImage");

    if (blurImages.length === 0) return; // 蟇ｾ雎｡縺後↑縺代ｌ縺ｰ蜃ｦ逅�＠縺ｪ縺�

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
            }
        });
    }, {
        root: null, // 繝薙Η繝ｼ繝昴�繝亥渕貅�
        threshold: 0.3 // 30%隕九∴縺溘ｉ逋ｺ轣ｫ
    });

    blurImages.forEach((image) => {
        observer.observe(image);
    });
}

// #sec05縺ｮ繝輔ぉ繝ｼ繝峨う繝ｳ
function initFadeInAnimation() {
    const fadeElements = document.querySelectorAll(".fadeIn, .fade-in");

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("active");
                    observer.unobserve(entry.target); // 荳蠎ｦ陦ｨ遉ｺ縺輔ｌ縺溘ｉ逶｣隕悶ｒ隗｣髯､
                }
            });
        },
        { threshold: 0.3 } // 30%隕九∴縺溘ｉ逋ｺ轣ｫ
    );

    fadeElements.forEach((el) => observer.observe(el));
}

function initFixedAreaObserver() {
    const sec06 = document.querySelector("#sec06");
    const fixedArea = document.querySelector(".fixedArea");

    if (!sec06 || !fixedArea) {
        return;
    }

    window.addEventListener("scroll", () => {
        const sec06Rect = sec06.getBoundingClientRect();
        const sec06Height = sec06.offsetHeight;
        const windowHeight = window.innerHeight;

        // `#sec06` 縺ｮ **50% 莉･荳翫′逕ｻ髱｢蜀�↓縺ゅｋ縺�** 繧貞愛螳�
        const isSec06HalfVisible =
            sec06Rect.top < windowHeight * 0.2 && sec06Rect.bottom > windowHeight * 0.2;

        // `#sec06` 縺悟ｮ悟�縺ｫ逕ｻ髱｢螟悶↓蜃ｺ縺溘→縺ｿ縺ｪ縺吝渕貅悶ｒ蟆代＠譌ｩ繧√ｋ
        const isSec06FullyOut = sec06Rect.bottom < windowHeight * 0.7 || sec06Rect.top > windowHeight;

        if (isSec06FullyOut) {
            // `#sec06` 縺ｮ邨ゆｺ�ｒ譌ｩ繧√↓讀懃衍縺励� `.fixedArea` 繧貞ｮ悟�髱櫁｡ｨ遉ｺ
            if (!fixedArea.classList.contains("hidden")) {
                fixedArea.classList.add("hidden");
                fixedArea.classList.remove("is-visible", "fade-out");
            }
        } else if (isSec06HalfVisible) {
            // `#sec06` 縺ｮ **50% 莉･荳翫′逕ｻ髱｢蜀�↓蜈･縺｣縺溘ｉ** `.fixedArea` 繧偵ヵ繧ｧ繝ｼ繝峨う繝ｳ
            if (!fixedArea.classList.contains("is-visible")) {
                fixedArea.classList.add("is-visible");
                fixedArea.classList.remove("hidden", "fade-out");
            }
        } else {
            // `#sec06` 縺ｮ **50% 莉･荳翫′逕ｻ髱｢螟悶↓蜃ｺ縺溘ｉ** `.fixedArea` 繧偵ヵ繧ｧ繝ｼ繝峨い繧ｦ繝�
            if (!fixedArea.classList.contains("fade-out")) {
                fixedArea.classList.add("fade-out");
                fixedArea.classList.remove("is-visible");
            }
        }
    });
}

//繝倥ャ繝繝ｼ髱櫁｡ｨ遉ｺ縺ｫ
function initHeaderObserver() {
    const footerWrap = document.querySelector(".footerWrap");
    const headerWrap = document.querySelector(".headerWrap");

    if (!footerWrap || !headerWrap) {
        console.error("笞��� footerWrap 縺ｾ縺溘� headerWrap 縺瑚ｦ九▽縺九ｊ縺ｾ縺帙ｓ");
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // `.footerWrap` 縺檎判髱｢蜀�↓蜈･縺｣縺溘ｉ `.headerWrap` 繧偵ヵ繧ｧ繝ｼ繝峨い繧ｦ繝�
                headerWrap.classList.add("fade-out");
            } else {
                // `.footerWrap` 縺檎判髱｢螟悶↓蜃ｺ縺溘ｉ `.headerWrap` 繧貞�陦ｨ遉ｺ
                headerWrap.classList.remove("fade-out");
            }
        });
    }, { rootMargin: "0px", threshold: 0.1 });

    observer.observe(footerWrap);
}

// 繧ｹ繝�繝ｼ繧ｹ繧ｹ繧ｯ繝ｭ繝ｼ繝ｫ繧貞ｮ溯｣�☆繧矩未謨ｰ
function initSmoothScroll() {
    const links = document.querySelectorAll('a[href^="#"]');
    
    links.forEach(link => {
        link.addEventListener("click", function(event) {
            event.preventDefault();
            
            const targetId = this.getAttribute("href").substring(1);
            const targetElement = document.getElementById(targetId);
            
            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop,
                    behavior: "smooth"
                });
            }
        });
    });
}

// #sec02縺ｨ#sec03縺ｯ繝�く繧ｹ繝郁牡縺碁ｻ偵°繧臥區縺ｫ
$(document).ready(function () {
    $(window).on("scroll", function () {
        let scrollTop = $(window).scrollTop();
        let sec02Top = $("#sec02").offset().top;
        let sec03Top = $("#sec03").offset().top;
        let sec03Bottom = sec03Top + $("#sec03").outerHeight();

        if (scrollTop >= sec02Top && scrollTop < sec03Bottom) {
            $(".headerWrap").css("color", "#fff"); // 譁�ｭ苓牡繧堤區縺ｫ
            $(".headerWrap svg").css({ "fill": "#fff", "stroke": "#fff" }); // SVG繧ら區縺ｫ
        } else {
            $(".headerWrap").css("color", "#000"); // 縺昴ｌ莉･螟悶�鮟偵↓謌ｻ縺�
            $(".headerWrap svg").css({ "fill": "#000", "stroke": "#000" }); // SVG繧るｻ偵↓
        }
    });
});

function initScrollTrigger() {
    const images = document.querySelectorAll(".imageList__item");
    
    function onScroll() {
        images.forEach(image => {
            const rect = image.getBoundingClientRect();
            if (rect.top < window.innerHeight * 0.8) {
                image.classList.add("active");
            }
        });
    }
    
    window.addEventListener("scroll", onScroll);
    onScroll(); // 蛻晏屓繝√ぉ繝�け
}

// 繧ｹ繧ｯ繝ｭ繝ｼ繝ｫ縺ｧ繝輔ぉ繝ｼ繝峨い繧ｦ繝医☆繧玖ｦ∫ｴ�縺ｮ蜃ｦ逅�
function initScrollFadeOut() {
    const scrollElement = document.querySelector(".scroll");
    if (!scrollElement) return; // 隕∫ｴ�縺悟ｭ伜惠縺励↑縺��ｴ蜷医�蜃ｦ逅�＠縺ｪ縺�

    window.addEventListener("scroll", () => {
        if (window.scrollY > 100) { // 100px莉･荳翫せ繧ｯ繝ｭ繝ｼ繝ｫ縺励◆繧蛾撼陦ｨ遉ｺ
            scrollElement.classList.add("hidden");
        } else {
            scrollElement.classList.remove("hidden");
        }
    });
}

// #sec06縺ｮ閭梧勹濶ｲ
function initBackgroundChangeObserver() {
    const target = document.querySelector("#sec06");

    if (!target) {
        console.warn("#sec06 縺瑚ｦ九▽縺九ｊ縺ｾ縺帙ｓ縲�");
        return; // #sec06 縺後↑縺��ｴ蜷医∝�逅�ｒ繧ｹ繧ｭ繝��
    }

    console.log("#sec06 縺ｮ逶｣隕悶ｒ髢句ｧ�");

    const observer = new IntersectionObserver(
        ([entry], observer) => {
            if (entry.isIntersecting) {
                target.classList.add("active");
                console.log("active 繧ｯ繝ｩ繧ｹ繧定ｿｽ蜉�");

                // 荳蠎ｦ逋ｺ轣ｫ縺励◆繧臥屮隕悶ｒ蛛懈ｭ｢�域綾繧峨↑縺上☆繧具ｼ�
                observer.disconnect();
                console.log("逶｣隕悶ｒ蛛懈ｭ｢");
            }
        },
        { threshold: 0.1 } // 10%陦ｨ遉ｺ縺ｧ逋ｺ轣ｫ
    );

    observer.observe(target);
}

// 繧ｯ繝ｬ繧ｸ繝�ヨ髢矩哩
function initCreditBtn() {
    const creditBtns = document.querySelectorAll(".creditBtn"); // 隍�焚蟇ｾ蠢�
  
    if (!creditBtns.length) return;
  
    creditBtns.forEach((creditBtn) => {
      const creditList = creditBtn.querySelector(".creditBtn__list, .creditBtn__list--side");
  
      if (!creditList) return;
  
      // iOS縺ｮ繧ｿ繝��繧堤｢ｺ螳溘↓讀懃衍縺吶ｋ
      let isTouchDevice = false;
  
      creditBtn.addEventListener("touchstart", function () {
        isTouchDevice = true;
      });
  
      // `click` 縺ｧ縺ｯ縺ｪ縺� `pointerdown` 繧剃ｽｿ縺�（Phone 縺ｧ繧ら｢ｺ螳溘↓蜍穂ｽ懊＆縺帙ｋ
      creditBtn.addEventListener("pointerdown", function (event) {
        event.stopPropagation(); // 繧ｯ繝ｪ繝�け繧､繝吶Φ繝医�莨晄眺繧帝亟縺�
  
        // 莉悶�髢九＞縺ｦ縺�ｋ繝ｪ繧ｹ繝医ｒ髢峨§繧�
        document.querySelectorAll(".creditBtn.is-open").forEach((otherBtn) => {
          if (otherBtn !== creditBtn) {
            otherBtn.classList.remove("is-open");
          }
        });
  
        // iOS縺ｮ蝣ｴ蜷医�蟇ｾ遲厄ｼ� touchstart 縺檎匱逕溘＠縺溘ｉ蜊ｳ譎る←逕ｨ
        if (isTouchDevice) {
          setTimeout(() => {
            creditBtn.classList.toggle("is-open");
          }, 0);
        } else {
          creditBtn.classList.toggle("is-open");
        }
      });
  
      // 隕∫ｴ�螟悶け繝ｪ繝�け縺ｧ髢峨§繧具ｼ�iPhone縺ｧ繧よｩ溯�縺吶ｋ繧医≧菫ｮ豁｣��
      document.addEventListener("pointerdown", function (event) {
        if (!creditBtn.contains(event.target)) {
          creditBtn.classList.remove("is-open");
        }
      });
  
      // creditList 蜀��繝ｪ繝ｳ繧ｯ繧呈款縺励※繧る哩縺倥↑縺�ｈ縺�↓縺吶ｋ
      creditList.addEventListener("pointerdown", function (event) {
        event.stopPropagation();
      });
    });
  }
    
// 繝ｭ繝ｼ繝�ぅ繝ｳ繧ｰ螳御ｺ�ｾ後↓螳溯｡後☆繧矩未謨ｰ
function initPageFunctions() {
    initFadeZoomScroll();
    initZoomAnimation();
    initCreditBtn();
    initSectionTextChange();
    initClipImageAnimation();
    initBgImageFadeAnimation();
    initBlurImageAnimation();
    initFadeInAnimation();
    initFixedAreaObserver();
    initHeaderObserver();
    initFadeSlider();
    initSmoothScroll();
    initScrollTrigger();
    initScrollFadeOut();
    initBackgroundChangeObserver();
}
